<template>
	<section class="h-100">
    <b-navbar-nav class="left-navbar hide" style="overflow:auto">
      <router-link to="/"><b-img src="./assets/img/evrice_rad.svg" style="width: 50%; padding: 20px 0 10px 0" /> </router-link>
      <b-nav-item :active="getActive('address')" v-if="logget" :to="{ path: '/address/'+ $store.state.address}">
        <template v-if="image">
          <b-img class="mx-auto" variant="default" :src="image" style="width: 32px;border-radius: 50%;"/>
          <span style="font-size: 12px">{{ $t('address.title') }}</span>
        </template>
        <template v-else>
          <i style="font-size: 28px;" class="fal fa-user-circle"/> <span style="font-size: 12px">{{ $t('address.title') }}</span>
        </template>
      </b-nav-item>
      <b-nav-item :active="getActive('inbox')"  v-if="logget" to="/inbox"><i style="font-size: 28px;" class="fal fa-comments-alt"><b-spinner v-if="$store.state.inbox" class="spinner-position" small variant="warning" type="grow" label="Spinning"/></i> <span style="font-size: 12px">{{ $t('inbox.title') }}</span></b-nav-item>
      <b-nav-item :active="getActive('articles')" to="/articles?address=0x9b7856db6dc27822bfb72f412ace95758cc448c7"><i style="font-size: 28px;" class="fal fa-comment-alt-lines"/><span style="font-size: 12px">{{ $t('article.title') }}</span></b-nav-item>
      <b-nav-item :active="getActive('wallet')" v-if="logget" to="/wallet"><i style="font-size: 28px;" class="fal fa-wallet"/><span style="font-size: 12px">{{ $t('wallet.title') }}</span></b-nav-item>
      <b-nav-item :active="getActive('explorer')" to="/explorer"><i style="font-size: 28px; margin-top: 0px" class="fal fa-window-restore"/><span style="font-size: 12px">{{ $t('explorer.title') }}</span></b-nav-item>
      <b-nav-item :active="getActive('exchange')" to="/exchange"><i style="font-size: 28px;" class="fal fa-sync-alt"/> <span style="font-size: 12px">{{$t('exchange.title')}}</span></b-nav-item>
      <hr style="width: 100%; border-color: #cbe1f8; margin-bottom: 0px; margin-top: 0px" />
      <b-nav-item :active="getActive('applications')" to="/applications"><i style="font-size: 28px;" class="fal fa-laptop-code"/> <span style="font-size: 12px">{{ $t('apps.title') }}</span></b-nav-item>
      <b-nav-item :active="getActive('API')" to="/API"><i style="font-size: 28px;" class="fal fa-info-circle"/> <span style="font-size: 12px">API</span></b-nav-item>
      <b-nav-item :active="getActive('signin')" v-if="!logget" to="/signin"><i style="font-size: 28px;" class="fal fa-chevron-circle-left"/><span style="font-size: 12px">{{ $t('signin.title') }}</span></b-nav-item>
      <b-nav-item :active="getActive('signup')" v-if="!logget" to="/signup"><i style="font-size: 28px;" class="fal fa-chevron-circle-right"/><span style="font-size: 12px">{{ $t('signup.title') }}</span></b-nav-item>
      <b-nav-item v-b-modal.modal-language><i style="font-size: 28px;" class="fal fa-globe-americas"/><span style="font-size: 12px">{{ $t('lang') }}</span></b-nav-item>
      <b-nav-item v-b-modal.modal-socio><i style="font-size: 28px;" class="fal fa-users"/><span style="font-size: 12px">{{ $t('index.ln2') }}</span></b-nav-item>
      <b-nav-item v-if="logget" @click="logout"><i style="font-size: 28px;" class="fal fa-times-circle"/> <span style="font-size: 12px">{{ $t('logout') }}</span></b-nav-item>
    </b-navbar-nav>

    <section id="app" class="h-100">
      <router-view/>
    </section>
		<b-modal id="modal-language" :title="$t('lang')" centered hide-footer>
      <span class="m-2 cursor-pointer" @click="locale('en')"><i class="mr-2"><svg width="26px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/><g><path style="fill:#0052B4;" d="M52.92,100.142c-20.109,26.163-35.272,56.318-44.101,89.077h133.178L52.92,100.142z"/><path style="fill:#0052B4;" d="M503.181,189.219c-8.829-32.758-23.993-62.913-44.101-89.076l-89.075,89.076H503.181z"/><path style="fill:#0052B4;" d="M8.819,322.784c8.83,32.758,23.993,62.913,44.101,89.075l89.074-89.075L8.819,322.784L8.819,322.784z"/><path style="fill:#0052B4;" d="M411.858,52.921c-26.163-20.109-56.317-35.272-89.076-44.102v133.177L411.858,52.921z"/><path style="fill:#0052B4;" d="M100.142,459.079c26.163,20.109,56.318,35.272,89.076,44.102V370.005L100.142,459.079z"/><path style="fill:#0052B4;" d="M189.217,8.819c-32.758,8.83-62.913,23.993-89.075,44.101l89.075,89.075V8.819z"/><path style="fill:#0052B4;" d="M322.783,503.181c32.758-8.83,62.913-23.993,89.075-44.101l-89.075-89.075V503.181z"/><path style="fill:#0052B4;" d="M370.005,322.784l89.075,89.076c20.108-26.162,35.272-56.318,44.101-89.076H370.005z"/></g><g><path style="fill:#D80027;" d="M509.833,222.609h-220.44h-0.001V2.167C278.461,0.744,267.317,0,256,0c-11.319,0-22.461,0.744-33.391,2.167v220.44v0.001H2.167C0.744,233.539,0,244.683,0,256c0,11.319,0.744,22.461,2.167,33.391h220.44h0.001v220.442C233.539,511.256,244.681,512,256,512c11.317,0,22.461-0.743,33.391-2.167v-220.44v-0.001h220.442C511.256,278.461,512,267.319,512,256C512,244.683,511.256,233.539,509.833,222.609z"/><path style="fill:#D80027;" d="M322.783,322.784L322.783,322.784L437.019,437.02c5.254-5.252,10.266-10.743,15.048-16.435l-97.802-97.802h-31.482V322.784z"/><path style="fill:#D80027;" d="M189.217,322.784h-0.002L74.98,437.019c5.252,5.254,10.743,10.266,16.435,15.048l97.802-97.804V322.784z"/><path style="fill:#D80027;" d="M189.217,189.219v-0.002L74.981,74.98c-5.254,5.252-10.266,10.743-15.048,16.435l97.803,97.803H189.217z"/><path style="fill:#D80027;" d="M322.783,189.219L322.783,189.219L437.02,74.981c-5.252-5.254-10.743-10.266-16.435-15.047l-97.802,97.803V189.219z"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></i>
        <span>English</span>
      </span>
			<span class="m-2 cursor-pointer" @click="locale('ru')"><i class="mr-2"><svg width="26px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/><path style="fill:#0052B4;" d="M496.077,345.043C506.368,317.31,512,287.314,512,256s-5.632-61.31-15.923-89.043H15.923C5.633,194.69,0,224.686,0,256s5.633,61.31,15.923,89.043L256,367.304L496.077,345.043z"/><path style="fill:#D80027;" d="M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></i>
        <span>Русский</span>
      </span>
		</b-modal>
    <b-modal id="modal-socio" :title="$t('index.ln1')" centered hide-footer>
      <b-card class="text-center mb-3" style="border-color: transparent; background-color: transparent; box-shadow: none">
        <a target="_blank" href="https://t.me/evrice"><i style="color: DodgerBlue; font-size: 45px;" class="fab fa-telegram mr-4"></i></a> &nbsp;
        <a target="_blank" href="https://facebook.com/evriceofficial"><i style="color: SteelBlue; font-size: 45px;" class="fab fa-facebook mr-4"></i></a> &nbsp;
        <a target="_blank" href="https://medium.com/@EvriceOfficial"><i style="font-size: 45px;" class="fab fa-medium-m mr-4"></i></a> &nbsp;
        <a target="_blank" href="https://bitcointalk.org/index.php?topic=5323219"><i style="color: goldenrod; font-size: 45px;" class="fab fa-bitcoin mr-4"></i></a> &nbsp;
        <a target="_blank" href="https://twitter.com/EvriceOfficial"><i style="color: DodgerBlue; font-size: 45px;" class="fab fa-twitter mr-4"></i></a> &nbsp;
        <a target="_blank" href="https://github.com/EVRICE"><i style="font-size: 45px;" class="fab fa-github mr-4"></i></a>
        <a target="_blank" href="https://www.reddit.com/r/Evrice/"><i style="font-size: 45px; color: #FF4500" class="fab fa-reddit mr-4"></i></a>
      </b-card>
    </b-modal>
	</section>
</template>

<script lang="js">

import Vue 						from 'vue';
import axios 					from 'axios';
import api 						from './libs/api';
import {Howl} 				from 'howler';
import VueNativeNotification 	from 'vue-native-notification';


Vue.use(VueNativeNotification, {
  requestOnNotify: true
});

export default {
  name: 'app',


  data() {
    return {
      name: null,
      image: null,
      sound: null,
      active: false,
    }
  },
  metaInfo() {
    return {
      title: 'Evrice Crypto',
      meta: [
        {vmid: 'description', property: 'description', content: this.$t('meta.description')},
        {vmid: 'keywords', property: 'keywords', content: this.$t('meta.keywords')},
        {vmid: 'og:title', property: 'og:title', content: 'Evrice Crypto'},
        {vmid: 'og:description', property: 'og:description', content: this.$t('meta.description')},
        {
          vmid: 'google-site-verification',
          property: 'google-site-verification',
          content: 'FtYt7u1JVwMPy-v8bYYaYpVgxbQpsQdnVmxLedzSlUM'
        },
      ]
    }
  },
  watch: {
    $route(scope) {
      if (scope.name !== "info.main") {
        axios.post(api.status).catch(() => {
          this.$router.push({name: 'info.main'}).catch((err) => {
            this.$log.info(err);
          })
        });
      }
    }
  },
  beforeCreate() {
    this._.delay(() => {
      this.$store.dispatch('getLocalStorageObject', 'account').then((account) => {
        if (account) {
          this.$options.sockets.onmessage = (message) => {

            let data = JSON.parse(message.data);
            this.$log.info(data);

            if (data.error === undefined) {
              if (data.result.data !== undefined) {

                if (data.result.data.type === "inbox") {
                  switch (data.result.data.sub) {
                    case "message":
                      if (this.$route.name !== "inbox.channel" && this.$route.name !== "inbox.main" && this.$route.name !== "inbox.guide") {

                        this.$notification.show(data.result.data.name ? data.result.data.name : data.result.data.address, {
                          body: data.result.data.text
                        }, {})
                        this.$store.commit('setInboxBadge', true);
                      }

                      this.play();
                      break;
                  }
                }
              }
            } else {
              this.$log.info(data.error);
            }
          }
        }
      });
    }, 5000);
  },
  created() {
    this.sound = new Howl({
      src: 'https://evrice.com/media/sound.ogg', // Добавить аудио звук нового сообщения в папку static/media/ -> sound.ogg
      html5: true,
      format: ['ogg']
    });
  },
  mounted() {
    this.session();
  },
  methods: {
    locale(locale) {
      // Set local storage.
      this.$root.$emit('bv::hide::modal', 'modal-language', '#modal-language');
      this.$store.commit('setLocalStorage', {'name': 'lang', 'value': locale});
      this.$i18n.locale = locale;
      this.$router.forward()
    },
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/');
      });
    },
    play() {
			this.sound.play();
		},
    session() {
      this.$store.dispatch('getLocalStorage', 'token').then((token) => {
        this.$store.state.logget = !!token;
        if (!this._.isNull(token)) {
          this.account();
        } else {
          this.$log.info("Welcome...");
        }
      });
    },
    account() {
      axios.post(api.account.info).then((response) => {

        this.$store.commit('setLocalStorage', {
          'name': 'account',
          'value': JSON.stringify(response.data)
        });

        this.$storage("account", response.data.address, response.data.image).then((image) => {
          this.$data.image = image;
        });

        this.$data.name = response.data.name;
        this.$store.state.inbox = response.data.inbox_badge;
        this.$store.state.address = response.data.address;
      });
    },


    getActive(name) {
      if (this.$route.name === null) {
        return false
      }
      return this.$route.name.split('.')[0] === name;
    },

        onOver() {
          this.$refs.dropdown.visible = true;
        },
        onLeave() {
          this.$refs.dropdown.visible = false;
        }

  },
  computed: {
    logget() {
      return this.$store.getters.logget;
    }
  }
}
</script>
